// SPDX-License-Identifier: GPL-3.0-only
// Copyright (C) 2026 Kyle Johnson
// This file is part of Hushold.
//
// Hushold is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as
// published by the Free Software Foundation, version 3.

import React from 'react';

// The Hushold mark: an H whose crossbar is a doubled equals sign — the letter
// H and the debits-equal-credits identity of double-entry accounting in one
// form. Inline copy of hushold-brand/logomark-currentColor.svg so it needs no
// asset request and can inherit color. Brand rule (hushold-brand/brand.md):
// the mark is drawn only in copper, bone, or dark — copper is the default.
const COPPER = '#BE8250';

interface LogomarkProps {
  /** Rendered height in px; width follows the 7:8 aspect ratio. */
  size?: number;
  /** 'copper' (default) or 'currentColor' to inherit the CSS color. */
  color?: 'copper' | 'currentColor';
  className?: string;
}

export function Logomark({ size = 20, color = 'copper', className }: LogomarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="15 10 70 80"
      width={(size * 70) / 80}
      height={size}
      aria-hidden="true"
      focusable="false"
      className={className}
      style={{ display: 'inline-block', flexShrink: 0 }}
      fill={color === 'copper' ? COPPER : 'currentColor'}
    >
      <rect x="23" y="18" width="11" height="64" />
      <rect x="66" y="18" width="11" height="64" />
      <rect x="40" y="35" width="20" height="9" />
      <rect x="40" y="56" width="20" height="9" />
    </svg>
  );
}
